module.exports = __webpack_public_path__ + "img/volleyball.33042479.jpg";